import React from "react";
import { TransactionProps } from "./types";
import {
  BarChart,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Bar,
  CartesianGrid,
  Tooltip,
  Rectangle,
} from "recharts";
import {
  colorLooper,
  domainFormatter,
  tickFormatter,
  transactionsToChartData,
} from "../../../../utils/helpers";
import CustomToolTip from "./CustomToolTip";
import ByteChip from "../../../icons/ByteChip";
import { Box } from "@mui/material";

export const chartColors: string[] = [
  "#F7BFBF",
  "#F7D68C",
  "#B4B4F6",
  "#F1A9F1",
];

export const grayVariant: string[] = [
  "#A3A3A3",
  "#DBDBDB",
  "#EDEDED",
  "#F7F7F7",
];

const BillingOverviewChart = (props: {
  transactions: TransactionProps[];
  billingMonth: Date;
  selectedDay?: string;
  setSelectedDay?: (day: string | undefined) => void;
}) => {
  const { transactions, billingMonth, selectedDay, setSelectedDay } = props;

  const chartData = transactionsToChartData(transactions, billingMonth) ?? [];

  const keys = Array.from(
    new Set(
      chartData?.flatMap((item) =>
        Object.keys(item).filter((key) => key !== "name" && key !== "fullDate")
      )
    )
  ).reverse();
  const CustomYAxisTick = ({ x, y, payload }: any) => {
    return (
      <foreignObject x={x - 45} y={y - 13} width={100} height={20}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <ByteChip size="xs" color="secondary" colorVariant="main" />
          <span
            style={{
              marginLeft: 1,
              color: "#9091FE",
              fontSize: "12px",
              fontWeight: 600,
              fontFamily: "Gilroy",
            }}
          >
            {payload.value.toLocaleString()}
          </span>
        </div>
      </foreignObject>
    );
  };

  return (
    <ResponsiveContainer height={250} width="100%">
      <BarChart width={500} height={300} data={chartData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="name"
          color="#9091FE"
          width={100}
          allowDataOverflow
          minTickGap={0}
          tickLine={false}
          tick={{
            fill: "#9091FE",
            fontSize: "12px",
            fontWeight: 600,
            fontFamily: "Gilroy",
          }}
          style={{
            userSelect: "none",
          }}
        />
        <YAxis
          domain={([dataMin, dataMax]) => domainFormatter(dataMin, dataMax)}
          tick={<CustomYAxisTick />}
          // tick={{
          //   fill: "#A3A3A3",
          //   fontSize: "12px",
          //   fontWeight: 600,
          //   fontFamily: "ByteNite Symbols",
          // }}
          style={{
            userSelect: "none",
          }}
          width={100}
          axisLine={false}
          tickCount={10}
          tickLine={false}
          tickFormatter={(value: number) => tickFormatter({ tickValue: value })}
          includeHidden
        />
        <Tooltip
          content={(props) => <CustomToolTip {...props} legends={keys} />}
        />
        {keys.map((key, index) => (
          <Bar
            key={key + index}
            dataKey={key}
            stackId="chart-data"
            fill={colorLooper(index, chartColors)}
            shape={(props: any) => {
              const isSelected = selectedDay === props.name;
              const color = isSelected
                ? colorLooper(index, chartColors)
                : colorLooper(index, grayVariant);
              return (
                <Rectangle
                  {...props}
                  fill={selectedDay ? color : colorLooper(index, chartColors)}
                />
              );
            }}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BillingOverviewChart;
